
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activate-account",
      function () {
        return require("private-next-pages/activate-account.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activate-account"])
      });
    }
  